import React, { useState } from "react";
import { ProjectsWrapper } from "../ProjectsWrapper";
import { Box, ClickAwayListener, Fade, Paper, Popper, Typography } from "@mui/material";
import { TextFieldWithoutBorders } from "../../components/TextFieldWithoutBorders";
import { TextAreaWithoutBorders } from "../../components/TextAreaWithoutBorders";
import OwnerSelectBox from "../../components/OwnerSelectBox";
import DepartmentSelectBox from "../../components/DepartmentSelectBox";
import PerfActionDateSelector from "../../components/PerfActionDateSelector";
import PerformanceActionsTable from "../../components/PerformanceActionsTable";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { editProject, getProjectDetails } from "../../api/projects";
import { setProjectDetails } from "../../redux/reducers/actionPlan";
import StatusIndicatorSmall from "../../components/StatusIndicatorSmall";
import './styles.css';
import StatusBox from "../../components/StatusBox";

const ProjectDetails = (props:any) => {
    const { isOpen, manageClickAway } = props;
    const currentProject = useSelector((state:any) => state.actionPlan.selectedProject);
    const details = useSelector((state:any) => state.actionPlan.details);
    const [isLoadingProjectDetails, setIsLoadingProjectDetails] = React.useState(false);
    const [isStateUpdated, setIsStateUpdated] = useState(false);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const dispatch = useDispatch();
    const [t] = useTranslation();
    var tempObj:any = {};
    
    const fetchProjectDetails = async () => {
        const response = await getProjectDetails({ projectId: currentProject?.id, pastStatusPeriod: 1 });
        dispatch(setProjectDetails(response));
        setIsLoadingProjectDetails(false);
    }
    React.useEffect(() => {
        if (!details && !isLoadingProjectDetails ||
            (currentProject &&
            Object.keys(currentProject).length && 
            details?.id !== currentProject?.id && 
            !isLoadingProjectDetails)) {
            setIsLoadingProjectDetails(true);
            fetchProjectDetails();
        }
    }, [currentProject]);

    const handleChangeState = async (updatedState:any) => {
        tempObj = {...details, ...updatedState};
        dispatch(setProjectDetails(tempObj));
        setIsStateUpdated(true);
        fetchProjectDetails();
        return true;
    }

    const manageUpdateProject = async () => {
        const response = await editProject({ projectId: details?.id, project: {...details} });
        setIsStateUpdated(false);
    }

    const handleSelectBox = async (newData:any) => {
        const isDone = await handleChangeState(newData);
        isStateUpdated && isDone && manageUpdateProject();
    }

    return(
        <React.Fragment>
            <Box sx={{ ml: '20px', width: '98%', height: '100%' }}>
                <Box className={'pdHeader'}>
                    <Box className='pdHeading'>
                        <Typography className='pdTitle'>{`${currentProject?.projectIndex ? 'P'+currentProject?.projectIndex : ''} ${details?.name}`}</Typography>
                        {/* <Typography className='fs14'>{details?.description ? details?.description : ''}</Typography> */}
                        <TextFieldWithoutBorders
                        value={details?.name ? details?.name : ''}
                        handleChange={(e:any) => {
                            const tempObj = {name: e.target.value};
                            handleChangeState(tempObj);
                        }}
                        placeholder={t('ENTER_ACTION_NAME')}
                        manageOnBlur={isStateUpdated && manageUpdateProject}
                        isReadOnly={isAdmin}
                        />
                        <TextAreaWithoutBorders
                        value={details?.description ? details?.description : ''}
                        handleChange={(e:any) => {
                            const tempObj = {description: e.target.value};
                            handleChangeState(tempObj);
                        }}
                        placeholder={t('ENTER_PROJECT_DESCRIPTION')}
                        manageOnBlur={isStateUpdated && manageUpdateProject}
                        isReadOnly={isAdmin}
                        />
                    </Box>
                    <Box className={'PDselectBoxWrapper mtbAuto'} onBlur={() => { isStateUpdated && manageUpdateProject() }}>
                        <OwnerSelectBox value={details?.assigneeUserId} manageSelect={handleSelectBox} dataLabel={'assigneeUserId'} isReadOnly={isAdmin} />
                        <DepartmentSelectBox value={details?.departmentId} manageSelect={handleSelectBox} ml={'0px'} isReadOnly={isAdmin} />
                        <StatusBox reportType={'rabg'} status={details?.status} isReadOnly={isAdmin} />
                        <PerfActionDateSelector value={details?.startDate} manageSelect={handleSelectBox} dataLabel={'startDate'} label={t('START_DATE')} ml={'0px'} isReadOnly={isAdmin}/>
                        <PerfActionDateSelector value={details?.dueDate} manageSelect={handleSelectBox} dataLabel={'dueDate'} ml={'0px'} isReadOnly={isAdmin} />
                    </Box>
                </Box>
                <Box className={'perfActionTableWrapper'}>
                <PerformanceActionsTable data={details?.actions} project={currentProject} isLoading={isLoadingProjectDetails} from={t('ACADEMY_GOALS')} isReadOnly={isAdmin} updateNewAction={handleChangeState} />
                </Box>
            </Box>
        </React.Fragment>
    )
}

export default ProjectDetails;